import { Content, List, Trigger } from '@radix-ui/react-navigation-menu';
import { styled } from '@components-shared/src/stitches';

export const ListContainer = styled(List, {
  display: 'flex',
  alignItems: 'center',
  listStyle: 'none',
  fontFamily: '$base',
  color: '$neutral800',
});

export const TriggerStyles = styled(Trigger, {
  base: 'M',
  fontStyle: 'medium',
  display: 'flex',
  columnGap: 17,
  alignItems: 'center',
  cursor: 'pointer',
  whiteSpace: 'nowrap',

  variants: {
    style: {
      header: {
        title: 'M',
        lineHeight: '21.6px',
        columnGap: 14,

        '@laptop': {
          title: 'XL',
        },
      },
    },
  },
});

export const DropdownContainer = styled(Content, {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  minWidth: 130,
  width: 'fit-content',
  padding: 16,
  zIndex: '$dropdown',
  background: '$neutral50',
  boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 6px 20px rgba(0, 0, 0, 0.2)',
  borderRadius: 8,
  fontSize: 16,
  left: 0,
  top: 32,

  '@tablet': {
    top: 30,
  },

  variants: {
    variant: {
      end: {
        right: 0,
        left: 'unset',
        '@tablet': {
          left: -10,
        },
      },
    },
    style: {
      header: {
        left: -14,
        borderRadius: 6,

        minWidth: 200,
        '@laptop': {
          top: 40,
          left: -18,
          minWidth: 285,
        },
      },
    },
  },
});

export const Option = styled('div', {
  fontSize: 14,
  fontWeight: 400,
  cursor: 'pointer',
  '&:hover': {
    fontWeight: 600,
  },

  '&:not(:last-child)': {
    marginBottom: 16,
  },

  variants: {
    style: {
      header: {
        fontStyle: 'medium',
        title: 'M',
        color: '$neutral400',

        '&:hover': {
          color: '$neutral800',
          fontWeight: 'unset',
        },

        '@laptop': {
          title: 'L',
          color: '$neutral400',
        },
      },
    },
  },
});
